<header>
  <div class="container mx-auto flex items-center justify-between">
    <!-- Logo and Name -->
    <div class="flex items-center">
      <span class="text-xl ml-3 font-bold">VIGI</span>
    </div>
    <!-- Kebab Icon -->
    <div class="flex items-center">
      <button (onblur)="toggleDropdown()" (click)="toggleDropdown()" class="focus:outline-none toggle-button">
        <img class="h-6 w-6" src="../../../../assets/icons/menu.png" />
      </button>
      <div [ngClass]="{'dropdown-open': isDropdownOpen}"
        class="header-wrapper absolute bg-white text-black rounded-md shadow-lg overflow-hidden">
        <div class="navigation-options">
          <span routerLink="/home" class="block px-4 py-2 text-sm">Exit</span>
          <span (click)="logout()" class="block px-4 py-2 text-sm">Logout</span>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="title-section h-10 flex items-center">
    <span class="ml-5">Reset your password</span>
</div>

<img class="vigi-icon mx-auto mt-20" src="../../../assets/icons/bot-icon.png" />

<div class="flex items-center justify-center mt-9">
    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="w-[180px] space-y-4">
        <input type="password" class="px-2 py-1 rounded-md border w-full placeholder:font-normal"
            placeholder="Old Password" formControlName="oldPassword" />

        <input type="password" class="px-2 py-1 rounded-md border w-full placeholder:font-normal"
            placeholder="New Password" formControlName="newPassword" />

        <input type="password" class="px-2 py-1 rounded-md border w-full placeholder:font-normal"
            placeholder="Re-enter New Password" formControlName="confirmPassword" />

        <div *ngIf="showPasswordMismatchError()" class="text-red-500 text-sm">
            Passwords do not match.
        </div>
        <button type="submit" class="bg-purple disabled:bg-purple-300 text-white px-4 py-2 rounded-md w-full" [disabled]="resetForm.invalid">
            Reset Password
        </button>
    </form>
</div>
<div *ngIf="showSuccessPopup" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded-lg shadow-lg text-center w-72">
        <p class="text-green-600 font-semibold mb-4">Password reset successful!</p>
        <button (click)="logout()" class="bg-purple text-white px-4 py-2 rounded-md">
            OK
        </button>
    </div>
</div>